import { useState } from "react";
import "./StaticCardComponent.css";

const StaticCardComponent = ({ imgSrc, title, text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="col static-card-component__col">
      <div className="card border-0 static-card-component__card">
        <img src={imgSrc} className="card-img-top" alt="..." />
        <div
          style={{
            paddingLeft: "0",
            paddingRight: "0",
            paddingBottom: "0",
            textAlign: "justify",
          }}
          className="card-body static-card-component__card-body service-card-body static-card-component__service-card-body"
        >
          <h5 className="card-title card-title-font static-card-component__card-title-font">
            {title}
          </h5>
          <p
            className="card-text card-text-font static-card-component__card-text-font"
            style={{ display: "inline" }}
          >
            {isExpanded ? text : `${text.slice(0, 100)}... `}
            <button
              className={`static-btn ml-2 static-card-component__static-btn`}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? (
                <span style={{ marginLeft: "8px" }}>See Less</span>
              ) : (
                "See More"
              )}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default StaticCardComponent;
